"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = Select;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _selectModule = _interopRequireDefault(require("./select.module.scss"));
var _common = require("../common");
var _excluded = ["value", "onChange", "id", "name", "className", "options", "disabled", "searchable", "clearable", "onFocus", "loading", "placeholder", "small", "menuPlacement", "formatValue", "inline", "dropdownIndicator", "error", "prefixIcon", "menuPosition", "isMulti", "styleMenu", "styleControl"],
  _excluded2 = ["children"];
function Select(_ref) {
  var _classNames;
  var value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    name = _ref.name,
    className = _ref.className,
    options = _ref.options,
    disabled = _ref.disabled,
    _ref$searchable = _ref.searchable,
    searchable = _ref$searchable === void 0 ? false : _ref$searchable,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? false : _ref$clearable,
    onFocus = _ref.onFocus,
    loading = _ref.loading,
    placeholder = _ref.placeholder,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? 'bottom' : _ref$menuPlacement,
    formatValue = _ref.formatValue,
    inline = _ref.inline,
    dropdownIndicator = _ref.dropdownIndicator,
    error = _ref.error,
    prefixIcon = _ref.prefixIcon,
    menuPosition = _ref.menuPosition,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    _ref$styleMenu = _ref.styleMenu,
    styleMenu = _ref$styleMenu === void 0 ? false : _ref$styleMenu,
    _ref$styleControl = _ref.styleControl,
    styleControl = _ref$styleControl === void 0 ? false : _ref$styleControl,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var getOption = (0, _react.useCallback)(function (value) {
    return options.find(function (o) {
      return o.value === value;
    });
  }, [options]);
  var _useState = (0, _react.useState)(function () {
      return getOption(value);
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  (0, _react.useEffect)(function () {
    if (value === undefined) {
      setSelectedOption(null);
    } else {
      setSelectedOption(getOption(value));
    }
  }, [value, options, getOption]);
  var handleChange = (0, _react.useCallback)(function (option) {
    setSelectedOption(option);
    var value = option ? option.value : undefined;
    onChange({
      currentTarget: {
        value: value
      }
    });
  }, [onChange]);
  var CustomControl = (0, _react.useCallback)(function (_ref2) {
    var children = _ref2.children,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_common.Control, Object.assign({
      prefixIcon: prefixIcon
    }, rest), children);
  }, [prefixIcon]);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, Object.assign({
    inputId: id,
    name: name,
    menuPosition: menuPosition,
    menuPortalTarget: menuPosition === 'fixed' ? document.body : undefined,
    className: (0, _classnames.default)(_selectModule.default['select__container'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _selectModule.default['select__container--small'], small), (0, _defineProperty2.default)(_classNames, _selectModule.default['select__container--inline'], inline), (0, _defineProperty2.default)(_classNames, _selectModule.default['select__container--error'], error), (0, _defineProperty2.default)(_classNames, _selectModule.default['select__container--top'], menuPlacement === 'top'), _classNames)),
    styles: {
      menuPortal: function menuPortal(base) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, base), {}, {
          zIndex: 250
        });
      },
      menu: function menu(base) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, base), {}, {
          right: styleMenu ? 0 : base.right
        });
      },
      control: function control(base) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, base), {}, {
          backgroundColor: styleControl ? '#f7f8fa' : base.backgroundColor
        });
      }
    },
    components: {
      DropdownIndicator: dropdownIndicator || (small ? _common.SmallDropdownIndicator : _reactSelect.components.DropdownIndicator),
      Option: _common.Option,
      Control: CustomControl,
      ClearIndicator: _common.ClearIndicator
    },
    classNamePrefix: "select",
    placeholder: placeholder,
    value: formatValue && selectedOption ? formatValue(selectedOption) : selectedOption,
    isDisabled: disabled,
    isSearchable: searchable,
    isClearable: clearable,
    isLoading: loading,
    onChange: handleChange,
    onFocus: onFocus,
    options: options,
    isMulti: isMulti
  }, props));
}